import _includes from 'lodash/includes';
import _flow from 'lodash/flow';
import _curry from 'lodash/curry';
import { Children, isValidElement } from 'react';


export var getChildren = function getChildren() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$props = _ref.props;

  _ref$props = _ref$props === undefined ? {} : _ref$props;
  var children = _ref$props.children;
  return children;
};
export var getChildrenAsArray = _flow([getChildren, Children.toArray]);
export var isOfType = _curry(function (type, child) {
  return child.type === type;
});
export var hasSlot = _curry(function (slots, child) {
  return isValidElement(child) && _includes(slots, child.props.slot);
});

export var slotOrder = _curry(function (order, slot) {
  var index = order.indexOf(slot.props.slot);
  return index === -1 ? Infinity : index;
});

export var isViewportScrollable = function isViewportScrollable() {
  return typeof window === 'undefined' ? true : (window.innerHeight || 0) < (window.document.documentElement.scrollHeight || 0);
};

export var isNoneOfType = function isNoneOfType(types) {
  return function (child) {
    return types.reduce(function (noneOf, Type) {
      return noneOf && !isOfType(Type, child);
    }, true);
  };
};

export var isNoneOfSlot = function isNoneOfSlot(slots) {
  return function (child) {
    return !hasSlot(slots, child);
  };
};

export var getProps = function getProps(_ref2) {
  var _ref2$props = _ref2.props,
      props = _ref2$props === undefined ? {} : _ref2$props;
  return props;
};

export var iOSVersion = function iOSVersion() {
  if (typeof window === 'undefined') return null;
  var _window$navigator$use = window.navigator.userAgent,
      userAgent = _window$navigator$use === undefined ? '' : _window$navigator$use;

  if (userAgent.includes('OS ') && userAgent.includes('iPhone')) {
    return Number(userAgent.substr(userAgent.indexOf('OS') + 3, 3).replace('_', '.'));
  }
  return null;
};

export var isIphone5 = function isIphone5() {
  return typeof window === 'undefined' ? null : Boolean(iOSVersion() >= 6 && window.devicePixelRatio >= 2 && screen.availHeight === 548);
};
//# sourceMappingURL=utils.js.map